


export default {
  message: {
    hello: '你好',
    products: '产品列表',
    home: '首页',
    about: '关于我们',
    contact: '联系我们',
    sitemap: '网站地图',
    language: '语言',
    chinese_simplified: '简体中文',
    english: '英文',
    vietnamese: '越南语',
    chinese_traditional: '繁体中文',
    sitemapSubtitle: '本站所有页面的完整索引，方便搜索引擎抓取和用户浏览',
    staticPages: '静态页面',
    productCategories: '产品分类',
    productList: '产品列表',
    allCategories: '所有分类',
    searchProducts: '搜索产品...',
    loadMore: '加载更多',
    xmlSitemap: 'XML网站地图',
    xmlSitemapDescription: '专用于搜索引擎的标准网站地图文件（sitemap.xml）',
    priority: '优先级',
    updateFrequency: '更新频率',
    productUnit: '个产品',
    loading: '加载中...',
    retry: '重试',
    fetchSitemapError: '获取网站地图失败，请稍后重试',
    daily: '每天',
    weekly: '每周',
    monthly: '每月'
  },
  pagination: {
    previous: '上一页',
    next: '下一页',
    page_info: '第 {current} / {total} 页 (共 {count} 条记录)'
  },
  product: {
    categories: {
      title: '产品分类',
      consumer_mosfet: '消费级Mosfet',
      industrial_mosfet: '工业级Mosfet',
      automotive_mosfet: '车规级Mosfet',
      power_module: 'Power Module',
      ovp: 'OVP',
      ldo: 'LDO',
      pmic: 'PMIC'
    },
    search: '搜索产品...',
    no_results: '没有找到匹配的产品',
    purchase_button: '购买',
    detail: {
      back: '返回',
      basic_info: '基本信息',
      technical_params: '技术参数',
      documents: '文档下载',
      download_pdf: '下载数据手册',
      loading: '加载中...',
      not_found: '产品不存在',
      load_error: '产品详情加载失败，请稍后重试。',
      fields: {
        Title: '产品名称',
        Package: '封装',
        ProductStatus: '产品状态',
        MOSFETType: 'MOSFET类型',
        Technology: '工艺技术',
        IDA: '漏极电流(A)',
        VDSMin: '漏源电压(V)',
        RDSon: '导通电阻(mΩ)',
        VGS: '栅源电压(V)',
        Qg: '总栅极电荷(nC)',
        Ciss: '输入电容(pF)',
        Coss: '输出电容(pF)',
        Crss: '反向传输电容(pF)',
        FileUrl: '数据手册'
      }
    },
    table: {
      model: '型号',
      package: '封装',
      product_status: '产品状态',
      mosfet_type: 'MOSFET类型',
      technology: '工艺',
      current: '电流',
      voltage: '电压',
      datasheet: '数据手册',
      view_pdf: '查看PDF',
      actions: '操作'
    }
  },
  about: {
    company_intro: '公司简介',
    company_desc: '765.info专注于为客户提供高性能、高可靠性的功率半导体解决方案。我们拥有先进的芯片设计技术和成熟的制造工艺，为工业自动化、新能源、智能家居、消费电子等领域提供优质的 MOSFET、DC-DC电源管理IC、AC-DC转换芯片等核心元器件，助力客户提升产品能效并降低系统成本。',
    
    core_advantages: '核心优势',
    advantage_direct_supply_title: '原厂直供',
    advantage_direct_supply_desc: '与原厂深度合作，确保正品货源，价格优势明显。',
    advantage_tech_leadership_title: '技术领先',
    advantage_tech_leadership_desc: '提供 VD-Trench、SJ-MOS、SGT-MOS 等先进工艺的功率器件，满足高效率、低损耗需求。',
    advantage_solution_support_title: '方案支持',
    advantage_solution_support_desc: '可提供 电机驱动、电源管理、LED照明 等参考设计，缩短客户研发周期。',
    advantage_quick_response_title: '快速响应',
    advantage_quick_response_desc: '现货库存+灵活供应链，支持小批量试样与大规模采购。',
    
    main_products: '主营产品',
    mosfet_series_title: 'MOSFET系列',
    mosfet_low_voltage: '中低压MOS（20V-200V）：适用于电动工具、锂电池保护。',
    mosfet_high_voltage: '高压MOS（500V-650V）：用于工业电源、光伏逆变器。',
    dcdc_chips_title: 'DC-DC降压芯片',
    dcdc_chips_desc: '系列（40V/2A）、（5V/3A），替代进口品牌。',
    acdc_chips_title: 'AC-DC转换芯片',
    acdc_chips_desc: '等方案，支持家电、智能电表等220V转5V/12V应用。',
    custom_services_title: '定制服务',
    custom_services_desc: '提供芯片选型、电路优化、模块化设计等技术支持。',
    
    service_areas: '服务领域',
    area_industrial_control: '工业控制（电机驱动、PLC）',
    area_new_energy: '新能源（储能、电动车充电桩）',
    area_consumer_electronics: '消费电子（快充、LED照明）',
    area_smart_home: '智能家居（家电、安防设备）',
    
    mission_vision: '使命愿景',
    mission_vision_desc: '我们以"让高效功率器件触手可及"为目标，结合专业技术实力与本地化服务，为客户提供稳定、创新的半导体解决方案。'
  },
  contact: {
    info_title: '联系方式',
    address_title: '公司地址',
    address_value: '深圳市宝安区福永街道凤凰社区广深路福永段109号锦灏大厦2305',
    phone_title: '电话',
    phone_value: '+86 13986263349',
    email_title: '电子邮箱',
    hours_title: '工作时间',
    hours_value: '周一至周五 9:00-18:00',
    form_title: '在线留言',
    name: '姓名',
    name_placeholder: '请输入您的姓名',
    email: '电子邮箱',
    email_placeholder: '请输入您的电子邮箱',
    subject: '主题',
    subject_placeholder: '请输入留言主题',
    message: '留言内容',
    message_placeholder: '请输入您的留言内容',
    submit: '提交',
    form_success: '您的留言已成功提交，我们将尽快与您联系！',
    location: '公司位置',
    map_placeholder: '地图加载中...',
    email_note: '提交后，我们的团队将收到您的消息',
    errorMessage: '邮件发送失败，请稍后再试。'
  }
}